import {createTransition} from "../../helpers";
export default () => createTransition();